import React from 'react';
import logo from '../assets/NHL_logo.png'; 
import avatar from '../assets/avatar.png';
import NotificationDropdown from '../components/NotificationDropdown';

function AddCourse() {
  return (
    <div>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Admin Panel</title>
        <div className="min-h-screen flex">
          <aside className="w-64 bg-white border-r border-gray-200 fixed h-full">
            <div className="px-6 py-4 border-b border-gray-200">
              <img src={logo} alt="Logo" className="h-18" />
            </div>
            <nav className="mt-6 px-3">
              <a href="/adminpanel" className="flex items-center px-3 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-50 mb-1">
                <i className="fas fa-home w-5 h-5 mr-2" />
                Dashboard
              </a>
              <a href="/courses" className="flex items-center px-3 py-2 text-sm font-medium rounded-md bg-black text-white mb-1">
                <i className="fas fa-book w-5 h-5 mr-2" />
                Courses
              </a>
              <a href="#" className="flex items-center px-3 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-50 mb-1">
                <i className="fas fa-file-alt w-5 h-5 mr-2" /> Submissions </a>
              <a href="#" className="flex items-center px-3 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-50">
                <i className="fas fa-users w-5 h-5 mr-2" />
                Users
              </a>
            </nav>
          </aside>
          <div className="flex-1 ml-64">
            <header className="bg-white shadow-sm">
              <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                  <h1 className="text-xl font-semibold text-gray-900 flex items-center">Create Course</h1>
                  <div className="flex items-center">
                  <NotificationDropdown />
                    <div className="ml-4 flex items-center">
                      <img className="h-8 w-8 rounded-full" src={avatar} alt="User" />
                      <span className="ml-2 text-sm font-medium text-gray-700">Admin User</span>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <main className="max-w-8xl mx-auto py-6 sm:px-6 lg:px-8">
                <div className="bg-white shadow rounded-lg">
                    <div className="px-6 py-6">
                    <form className="space-y-6">
                        <div className="grid grid-cols-2 gap-6">

                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700">
                            Course Name
                            </label>
                            <input
                            type="text"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom focus:border-custom"
                            placeholder="Enter course name"
                            />
                        </div>

                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700">
                            Course Description
                            </label>
                            <textarea
                            rows={4}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom focus:border-custom"
                            placeholder="Enter course description"
                            defaultValue={""}
                            />
                        </div>

                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700">
                            SharePoint Folder Link
                            </label>
                            <input
                            type="url"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom focus:border-custom"
                            placeholder="https://sharepoint.com/folder"
                            />
                        </div>

                        <div className="col-span-1">
                            <label className="block text-sm font-medium text-gray-700">
                            Start Date
                            </label>
                            <input
                            type="date"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom focus:border-custom"
                            />
                        </div>

                        <div className="col-span-1">
                            <label className="block text-sm font-medium text-gray-700">
                            End Date
                            </label>
                            <input
                            type="date"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom focus:border-custom"
                            />
                        </div>

                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700">
                            Examiners
                            </label>
                            <select
                            multiple
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom focus:border-custom"
                            >
                            <option>Dr. Smith</option>
                            <option>Dr. Johnson</option>
                            <option>Dr. Brown</option>
                            <option>Dr. Davis</option>
                            </select>
                        </div>

                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700">
                            Document Upload Deadline
                            </label>
                            <input
                            type="datetime-local"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom focus:border-custom"
                            />
                        </div>

                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700">
                            Maximum Students
                            </label>
                            <input
                            type="number"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom focus:border-custom"
                            placeholder="Enter maximum number of students"
                            />
                        </div>

                        </div>

                        <div className="mt-6 flex justify-end space-x-3">
                        <button
                            type="button"
                            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black hover:bg-custom-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-custom"
                        >
                            Create Course
                        </button>
                        </div>

                    </form>
                    </div>
                </div>
        </main>
 </div>
        </div>
        <footer className="bg-white border-t border-gray-200 fixed bottom-0 w-full">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="py-4 text-center text-sm text-gray-500">
              <p>© 2024 NHL Stenden. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
  );
}

export default AddCourse;
